import { RouterProvider } from "@tanstack/react-router";
import React from "react";
import ReactDOM from "react-dom/client";
import { ErrorBoundary } from "$/modules/shared/ui/error-boundary";
import { getRouter } from "./router";

// Erstelle den Router mit globalen Fehler- und 404-Fallbacks, damit ein
// Fehler in einer Route (Loader, Render) nicht die gesamte App abstürzen lässt.
const router = getRouter();

// Unbehandelte Promise-Rejections / globale Fehler protokollieren, statt sie
// stillschweigend verschwinden zu lassen. Render-Fehler fangen die Boundaries.
window.addEventListener("unhandledrejection", (event) => {
	console.error("Unhandled promise rejection:", event.reason);
});
window.addEventListener("error", (event) => {
	console.error("Global error:", event.error ?? event.message);
});

const rootElement = document.getElementById("root");

if (!rootElement) {
	throw new Error("Root element not found");
}

ReactDOM.createRoot(rootElement).render(
	<React.StrictMode>
		<ErrorBoundary>
			<RouterProvider router={router} />
		</ErrorBoundary>
	</React.StrictMode>,
);
